import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RateIndexLookupModel } from 'app/generated/backend/trade/api/rate-index-lookup-model';
import { BaseIdInputTypeaheadComponent } from 'app/_templates/base-id-input-typeahead/BaseIdInputTypeaheadComponent';
import { RateIndexLookupService } from './RateIndexLookupService';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => RateIndexLookupComponent),
	multi: true
};

export const CUSTOM_INPUT_CONTROL_VALIDATORS: any = {
	provide: NG_VALIDATORS,
	useExisting: forwardRef(() => RateIndexLookupComponent),
	multi: true
};

@Component({
    selector: 'app-rate-index-lookup',
    templateUrl: '../../_templates/base-id-input-typeahead/BaseIdInputTypeaheadComponent.html',
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR, CUSTOM_INPUT_CONTROL_VALIDATORS],
    standalone: false
})
export class RateIndexLookupComponent extends BaseIdInputTypeaheadComponent<RateIndexLookupModel> {

	@Input()
	public required: boolean = false;

	@Input()
	public disabled: boolean = false; 

	@Input()
	public addNew: boolean = false;

	@Input()
	public maxOptions: number;

	@Input()
	public label: string;

	@Input()
	public iconClass: string;

	@Input()
	public placeholder: string = '';

	@Input()
	public helpUri: string;

	@Input()
	public hint: string;

	@Output()
	itemSelected: EventEmitter<RateIndexLookupModel> = new EventEmitter<RateIndexLookupModel>();

	constructor(protected service: RateIndexLookupService) {
		super(service);
	}

	toDisplayText(item: RateIndexLookupModel): string {
		if (!item) {
			return null;
		}
		return item.code;
	}

	toOptionText(item: RateIndexLookupModel): string {
		if (!item) {
			return null;
		}
		return item.code + '/' + item.name;
	}
}
